import template from './differential-detail.html';
import controller from './differential-detail.controller';

let differentialDetailComponent = {
  bindings: {},
  template,
  controller
};

export default differentialDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/differential/differential-detail.component.js